import React from "react";

// One of the four cards above the table. Two display modes:
//   - default: big numeric `value` (e.g. "0")
//   - `custom`: pass any node (used for the "Next major window" card that
//     shows a flag + country name instead of a number)
//
// `icon` is expected to be a JSX element (from icons.js) that already
// has its own colored background baked in — we render it directly, no
// wrapper styling.
export default function KpiCard({ label, value, sub, icon, custom }) {
  return (
    <div className="bg-white border border-[#E5E5E5] rounded-2xl p-4 flex flex-col gap-1">
      <div className="flex flex-row items-center justify-between gap-2">
        <span className="text-[12px] font-semibold uppercase tracking-wider text-[#45556C]">
          {label}
        </span>
        {icon}
      </div>
      {custom ? (
        <div className="pt-2">{custom}</div>
      ) : (
        <div
          className="text-3xl font-bold text-[#0F172B] pt-2"
          style={{ lineHeight: "36px", letterSpacing: "0.4px" }}
        >
          {value}
        </div>
      )}
      <div className="text-sm text-[#434654] pt-0.5">{sub}</div>
    </div>
  );
}
